<template>
  <section>
    <form class="topup-form" @submit.prevent="submit" v-form:form novalidate>
      <div class="topup-form-frame">
        <div class="topup-loading" v-if="loading">{{ $t('component.register.loadingText') }}</div>
        <div>
          <h2 v-html="$t('component.register.title')"></h2>
          <div class="topup-form-fields">
            <div>
              <div>
                <section class="topup-form-field-zone">
                  <div class="topup-form-field">
                    <div class="topup-form-field-container">
                      <label for="msisdn">{{ $t('component.register.labelPhone') }} *</label>
                      <input type="text"
                             ref="msisdn"
                             inputmode="numeric"
                             v-model.trim="formData.msisdn"
                             required
                             phone
                             id="msisdn"
                             name="msisdn"
                             v-mask="'###-###-###'"
                             placeholder="___-___-___">
                    </div>
                    <div class="topup-form-error-container phone-error"
                         v-if="isErrorForField('msisdn')"
                         v-html="getFieldErrorText('msisdn')">
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div>
              <section class="topup-form-field-zone">
                <div class="topup-form-field">
                  <div class="topup-form-field-container">
                    <label for="iccid">{{ $t('component.register.labelEmail') }} *</label>
                    <input type="text"
                           ref="iccid"
                           inputmode="numeric"
                           v-model.trim="formData.iccid"
                           required
                           simNumber
                           id="iccid"
                           name="iccid"
                           :placeholder="$t('component.register.placeholderEmail')">
                  </div>
                  <div class="topup-form-error-container phone-error"
                       v-if="isErrorForField('iccid')"
                       v-html="getFieldErrorText('iccid')">
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div class="rodo" v-html="$t('component.register.rodoText')"></div>
        </div>
      </div>
      <div class="topup-form-buttons">
        <span></span>
        <button type="submit"
                class="btn"
                :class="{disabled: !isFormValid()}">
          {{ $t('component.register.buttonNext') }} ›
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import FormMixin from '@/sim-plus/mixins/form.mixin'
import { mapActions, mapState } from 'vuex'
import { ToolsClass } from '@/common/class/tools.class'
import { REGISTER_ERRORS, REGISTER_METHOD } from '@/common/const/registerSim.const'
import { Notifier, NOTIFY_TYPE } from '@/common/class/notify.class'

export default {
  name: 'RegisterForm',
  mixins: [FormMixin],
  data () {
    return {
      formData: {
        msisdn: null,
        iccid: null,
        termsAccepted: true
      }
    }
  },
  computed: {
    ...mapState({
      loading: state => state.registersim.loading,
      redirectUrl: state => state.registersim.redirectUrl,
      stage: state => state.topup.stage
    })
  },
  methods: {
    ...mapActions([
      'sendRegisterSimData'
    ]),
    submit () {
      if (!this.isFormValid()) {
        return
      }
      const data = {
        msisdn: '48' + ToolsClass.getPhoneNumberWithoutPrefix(ToolsClass.cleanPhoneNumber(this.formData.msisdn)),
        iccid: this.formData.iccid,
        verificationType: REGISTER_METHOD.fotoverify,
        termsAccepted: this.formData.termsAccepted
      }
      this.sendRegisterSimData(data)
        .then(() => {
          document.location.href = this.redirectUrl
        })
        .catch(error => {
          Notifier.show({
            text: `<i class="el-icon-warning" style="color:red;padding-right:5px;"></i>&nbsp;${this.$t('validation.processError')}`,
            type: NOTIFY_TYPE.error,
            autoClose: 5000
          })
          switch (error.statusDescription) {
            case REGISTER_ERRORS.msisdnInvalidOperator:
              this.addErrorToField('msisdn', 'operator')
              break
            case REGISTER_ERRORS.checkSimError:
            case REGISTER_ERRORS.invalidIccidForMsisdn:
              this.addErrorToField('iccid', 'sim')
              break
            case REGISTER_ERRORS.alreadyRegistered:
              this.addErrorToField('msisdn', 'registered')
              break
            case REGISTER_ERRORS.validationError:
              if (Array.isArray(error.errors)) {
                error.errors.forEach(item => {
                  this.addErrorToField(item.field, item.message)
                })
              }
              break
          }
        })
    }
  }
}
</script>

<style src="../../assets/scss/topup-form.scss" lang="scss"></style>
